import { computed, MaybeRef, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticatedAnd } from '@/utils/query-utils'

export const useGeneratorDetailsQuery = (generatorId: MaybeRef<string | undefined>) => {
    return useQuery({
        queryKey: ['generators', generatorId, 'details'],
        queryFn: async ({ signal }) => {
            const id = toValue(generatorId)

            if (id === undefined) {
                return
            }

            const {
                data: { result },
            } = await hcaClientFactory.masterDataApi.getGeneratorDetails(encodeURIComponent(id), {
                signal,
            })
            
            return result
        },
        enabled: whenAuthenticatedAnd(computed(() => !!toValue(generatorId))),
    })
}
